import React, { useContext, useEffect, useState } from "react";
import "./SuccessfullPopup.scss";
import AppContext from "../../config/AppContext";
import { ReactComponent as SuccessIcon } from "../../assets/images/ralvie/subsuccess.svg";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { sidebarContext } from "../../util/context";
import CommonUtil from "../../util/CommonUtils";
import { getloggedCompanySubscription } from "../../services/Subscription";

const SuccessfullPopup = ({ open, onClose }) => {
  const { mode } = useContext(AppContext);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [expiresAt, setExpiresAt] = useState("");

  useEffect(() => {
    const fetchSubscriptionDetails = async () => {
      try {
        const response = await getloggedCompanySubscription();
        if (response?.data?.data?.expiresAt) {
          setExpiresAt(CommonUtil.formateDateWithNameLocale(response?.data?.data?.expiresAt));
        }
      } catch (err) {
        console.error("Failed to fetch subscription details:", err);
      }
    };
      fetchSubscriptionDetails();
  }, []);

  const handleSuccessClick = () => {
    onClose();
    navigate("/subscription-manage");
    window.location.reload();
  };

  const handleBackdropClick = (e) => {
    if (e.target.classList.contains("backdrop")) {
      onClose();
    }
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Enter") {
        handleSuccessClick();
      } else if (event.key === "Escape" && open) {
        onClose();
      }
    };

    if (open) {
      window.addEventListener("keydown", handleKeyDown);
    }

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [open, handleSuccessClick]);

  if (!open) return null;

  return (
    <div className="backdrop" onClick={handleBackdropClick}>
      <div
        className={
          mode === "dark"
            ? "popup-containersuccessDark"
            : "popup-containersuccess"
        }
      >
        <div className="popup-iconsuccess">
          <SuccessIcon className="success-icon" />
        </div>
        <div className="title-containersuccess">
          <span
            className={
              mode === "dark" ? "popup-titlesuccessDark" : "popup-titlesuccess"
            }
          >
            {t("RAL0890")}
          </span>
        </div>
        <div className="popup-messagecontainersuccess">
          <span
            className={
              mode === "dark"
                ? "popup-messagesuccessDark"
                : "popup-messagesuccess"
            }
          >
            {" "}
            {t("RAL0891") + " " + expiresAt}
          </span>
        </div>
        <div className="popup-message2containersuccess">
          <span
            className={
              mode === "dark"
                ? "popup-messagesuccessDark"
                : "popup-messagesuccess"
            }
          >
            {t("RAL0892")}
          </span>
        </div>
        <div className="popup-footercancellationsuccess">
          <button className="footerconfirmsuccess" onClick={handleSuccessClick}>
            {t("RAL0893")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SuccessfullPopup;
